/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AwardCupIcon32Regular = forwardRef('AwardCupIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 6a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v5a6 6 0 0 1-5.505 5.98A9.009 9.009 0 0 1 17 22.945V28h5a1 1 0 1 1 0 2H10a1 1 0 1 1 0-2h5v-5.055a9.009 9.009 0 0 1-7.495-5.965A6 6 0 0 1 2 11V6Zm22.957 8.885A4.002 4.002 0 0 0 28 11V6h-3v8c0 .299-.015.594-.043.885ZM4 6h3v8c0 .299.015.594.043.885A4.002 4.002 0 0 1 4 11V6Zm5 0v8a7 7 0 1 0 14 0V6H9Z" })));
});
